export const inputFormStyle = `
  .searchform__input--form {
    width: 100%;
    height: 3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background-color: #FAE5B0;
    border-radius: 1.5rem;
    padding: 0 1em;
  }
  .searchform__input--form input {
    width: 80%;
    height: 90%;
    background-color: #FAE5B0;
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 1rem;
  }
  .searchform__input--form input:-webkit-autofill {
    background-color: transparent !important;
    -webkit-box-shadow: 0 0 0 50px #FAE5B0 inset;
  }
  .searchform__input--form input::placeholder {
    color: #716F87;
  }
  .searchform__input--form img {
    height: 1.5rem;
  }
  .searchform__arrow-left_lupe_icon {
    cursor:pointer;
  }
`

export const searchFormStyle = `
  .searchform__container {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 1.5rem;
    padding: 0.5em 1em;
    box-shadow: 1px 4px 4px rgb(0 0 0 / 10%);
    gap: 1em 0;
  }
  .searchform__input-form-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .searchform__arrow-left--container {
    width: 3rem;
    height: 3rem;
    padding: 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #E0E0E0;
    border-radius: 3rem;
    cursor: pointer;
    margin: 1em 0;
  }
  .searchform__arrow-left--container:hover {
    opacity: 0.7;
  }
  .searchform__arrow-left--container img {
    object-fit: contain;
  }
  .searchform__button_create {
    width: 100%;
    height: 3rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins';
    font-size: 1rem;
    color: #fff;
    padding: 0 1em;
    background: linear-gradient(171.14deg, #EEAB28 3.14%, #EE7628 20.68%, #DA5600 103.69%);
    border-radius: 1.5rem;
  }
  .searchform__button_create:hover {
    box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);
  }
  @media screen and (min-width: 768px) {
    .searchform__container {
      justify-content: flex-end;
      align-items: flex-end;
    }
    .searchform__button_create {
      width: 15rem;
      gap: 0 1em;
      padding: 0 1em;
    }
  }
  @media screen and (min-width: 1280px) {
    .searchform__container {
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 4rem;
      padding: 0 2em;
      justify-content: space-between;
    }
    .searchform__input-form-container {
      width: 60%;
      flex-direction: row;
      align-items: center;
    }
    .searchform__arrow-left--container {
      margin: 0 1em;
    }
  }
`